import { render, staticRenderFns } from "./ContextView.vue?vue&type=template&id=70633136&scoped=true&"
import script from "./ContextView.vue?vue&type=script&lang=js&"
export * from "./ContextView.vue?vue&type=script&lang=js&"
import style0 from "./ContextView.vue?vue&type=style&index=0&id=70633136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70633136",
  null
  
)

export default component.exports